'use strict';

window.Groupon.Utils.lazyLoadImages();
